<template>
  
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tloanapply}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input
            v-model="dataForm.custName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-select v-model="dataForm.companyId" filterable clearable placeholder="机构名称" @change="getId">
            <el-option v-for="item in userType" :key="item.value" :label="item.label" :value="item.id">
            </el-option>
          </el-select> -->
          <ren-dept-tree
            v-model="dataForm.companyId"
            :placeholder="$t('dept.title')"
            :query="true"
            ref="tree"
          >
        </ren-dept-tree>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="录单开始日期"
                    end-placeholder="录单结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="借款编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.mobile"
            placeholder="手机号"
            clearable
          >
        </el-input>
        </el-form-item>
        <el-form-item>
         <el-select v-model="dataForm.applyStatus" filterable clearable placeholder="状态">
           <el-option v-for="item in  applyStatusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
         </el-select>
        </el-form-item>
        <el-form-item>
         <el-select v-model="dataForm.lendingStatus" filterable clearable placeholder="放款状态">
           <el-option v-for="item in  loanStatusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
         </el-select>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="放款开始日期"
                    end-placeholder="放款结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes1"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
        <el-select v-model="dataForm.payChannelId" placeholder="支付渠道">
          <el-option
            v-for="(item,index) in channelList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
        <el-form-item>
          <el-button @click="getDataList('dept')">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item v-if="$hasPermission('loan:tloanapply:export')">
          <el-button 
            :disabled="isExporting"
            @click="handleExport()"
          >
            {{ $t("export") }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
        :height="maxHeight"
      >
      <!-- <el-table-column
          prop="licensee"
          label="持牌方"
          header-align="center"
          align="center"
        ></el-table-column> -->
      <el-table-column
          prop="companyName"
          label="部门"
          header-align="center"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="借款编号"
          header-align="center"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            <span class="blue" @click="elitRecord(scope.row)">
              {{ scope.row.agreementCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="custName"
          label="借款人/抵押人"
          width="120px"
          header-align="center"
          align="center"
           fixed="left"
        ></el-table-column>
        <el-table-column
          prop="coBorrower"
          label="共借人/共借企业"
          width="140px"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            <div>{{scope.row.coBorrower}}</div>
            <el-button class="look-idNo" v-if="scope.row.coBorrower && scope.row.borrowerType !='ENTERPRISE'"  type="text" size="small" @click="lookIdNo(scope.row,1)">查看证件</el-button>
  
          </template>
      </el-table-column>
      <el-table-column
          prop="mortGaGerName"
          label="抵押共有人"
          width="140px"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            <div>{{scope.row.mortGaGerName}}</div>
            <el-button class="look-idNo" v-if="scope.row.mortGaGerName"  type="text" size="small" @click="lookIdNo(scope.row,3)">查看证件</el-button>
        </template>
      </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="idNo"
          label="身份证号"
          header-align="center"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="totalAmount"
          label="总金额"
          header-align="center"
          align="center"
        ></el-table-column> -->
        <!-- <el-table-column prop="loanAmountFee" label="手续费" header-align="center" align="center"></el-table-column> -->
        <el-table-column
          prop="loanAmount"
          label="借款金额"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
          <div>{{scope.row.loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
        </template>
      </el-table-column>
        <el-table-column
          prop="productName"
          label="借款产品"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bankCardNo"
          label="收款方银行卡号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applyStatus"
          label="状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.applyStatus == '0'"> 失败 </span>
            <span v-else-if="scope.row.applyStatus == '-1'"> 资金退回中 </span>
            <span v-else-if="scope.row.applyStatus == '1'"> 放款成功 </span>
            <span v-else-if="scope.row.applyStatus == '2'"> 待签约 </span>
            <span v-else-if="scope.row.applyStatus == '3'"> 借款协议签署中 </span>
            <span v-else-if="scope.row.applyStatus == '4'"> 待放款 </span>
            <span v-else-if="scope.row.applyStatus == '10'"> 放款中 </span>
            <span v-else-if="scope.row.applyStatus == '5'"> 放款失败 </span>
            <span v-else-if="scope.row.applyStatus == '6'"> 提现中 </span>
            <span v-else-if="scope.row.applyStatus == '7'"> 取消 </span>
            <span v-else-if="scope.row.applyStatus == '8'"> 退回 </span>
            <span v-else-if="scope.row.applyStatus == '9'"> 退回失败 </span>
            <span v-else-if="scope.row.applyStatus == '11'">借款合同解约中 </span>
            <span v-else-if="scope.row.applyStatus == '12'"> 已解约 </span>
            <span v-else-if="scope.row.applyStatus == '13'">
              债权转让签署中
            </span>
            <span v-else-if="scope.row.applyStatus == '14'">
              债权转让签署成功
            </span>
            <span v-else-if="scope.row.applyStatus == '15'">
              债权转让签署失败
            </span>
            <span v-else> </span>
            <span v-if="scope.row.applyStatus == '16'"> 债权转让通知书签署中 </span>
            <span v-if="scope.row.applyStatus == '17'"> 债权转让完成 </span>

            <span v-if="scope.row.applyStatus == '18'"> 贷款协议链接失效 </span>
            <span v-if="scope.row.applyStatus == '19'"> 借款解约链接失效 </span>
            <span v-if="scope.row.applyStatus == '20'"> 债权转让链接失效 </span>
            <span v-if="scope.row.applyStatus == '21'"> 债权转让通知书链接失效 </span>
            <span v-if="scope.row.applyStatus == '22'">债权转让通知书签署失败</span>
            <span v-if="scope.row.applyStatus == '23'">债转解约签署中</span>
            <span v-if="scope.row.applyStatus == '24'">债转解约成功</span>
            <span v-if="scope.row.applyStatus == '25'">重签债权转让签署中</span>
            <span v-if="scope.row.applyStatus == '26'">重签债转成功</span>
            <span v-else-if="scope.row.applyStatus == '27'">结清证明签署中</span>
            <span v-else-if="scope.row.applyStatus == '28'">已结清</span>
            <span v-else-if="scope.row.applyStatus == '29'">待债转</span>
            <span v-else-if="scope.row.applyStatus == '30'">债权转让签约失败</span>
            <span v-else-if="scope.row.applyStatus == '31'">重签债转协议失败</span>
            <span v-else-if="scope.row.applyStatus == '32'">结清证明签署失败</span>
            <span v-else-if="scope.row.applyStatus == '33'">提现失败</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="notificationStatus"
          label="债权转让通知书状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.notificationStatus == '16'"> 债权转让通知书签署中 </span>
            <span v-if="scope.row.notificationStatus == '2'"> 待签约 </span>
            <span v-if="scope.row.notificationStatus == '21'"> 债权转让通知书链接失效 </span>
            <span v-if="scope.row.notificationStatus == '22'">债权转让通知书签署失败</span>
            <span v-if="scope.row.notificationStatus == '17'"> 债权转让通知书签约成功 </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payChannelId"
          label="三方支付"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            <span v-if="scope.row.payChannelId == 0"> 连连支付 </span>
            <span v-else-if="scope.row.payChannelId == 1"> 统统付 </span>
          </template>
        </el-table-column>
        <el-table-column
          label="放款状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.lendingStatus == '1'"> 放款成功 </span>
            <span v-else-if="scope.row.lendingStatus == '4'"> 待放款 </span>
            <span v-else-if="scope.row.lendingStatus == '10'"> 放款中 </span>
            <span v-else-if="scope.row.lendingStatus == '5'"> 放款失败 </span>
            <span v-else-if="scope.row.lendingStatus == '9'"> 退回失败 </span>
            <span v-else-if="scope.row.lendingStatus == '8'"> 退回成功 </span>
          </template>
        </el-table-column>
        <el-table-column
        width="100"
          label="放款时间"
          prop="loanTime"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
        width="100"
          prop="transferTime"
          label="债权转让时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="公证"
          header-align="center"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.isNotarization == false && $hasPermission('loan:transfer:notarization')" class="clearance" @click="notarization(scope.row)">公证</div>
            <div v-else-if="scope.row.isNotarization == true">
              <div>已公证</div>
              <div>日期：{{scope.row.notarizationDate.match(/^\d{4}-\d{2}-\d{2}/)[0]}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="capitalPlatformCode"
          label="操作"
          width="180"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.applyStatus == '8' || scope.row.applyStatus == '4' &&
                $hasPermission('api:trans:transfer')
              "
              @click="signedOK(scope.row)"
              
            >
             <div class="release">放款</div>
            </div>
            <div
              v-if="
                applyStatus(scope.row.applyStatus, '1') &&
                $hasPermission('loan:tloanapply:cancel')
              "
              
            >
            <el-popconfirm title="请确定是否解约" @confirm="sign(scope.row, 1)">
              <div  slot="reference" class="cancel_agree" style="font-weight: 650;">解约</div>
            </el-popconfirm>
              
            </div>
           
            <div
              v-if="
                applyStatus(scope.row.applyStatus, '2') &&
                $hasPermission('loan:tloanapply:sign')
              "
              @click="sign(scope.row, 2)"
              class="blue"
              style="font-weight: 650;"
            >
              <span class="cancel_agree" v-if="scope.row.applyStatus=='18'">签署借款协议</span>
              <span class="cancel_agree" v-if="scope.row.applyStatus=='2' || scope.row.applyStatus=='0'">签约</span>
              <span class="cancel_agree" v-if="scope.row.applyStatus=='0'">签署债转协议</span>
            
            </div>
             <!-- 获取链接 -->
             <div
              v-if="
                scope.row.applyStatus == '3' || scope.row.applyStatus == '13' || scope.row.applyStatus == '16' || scope.row.applyStatus == '11'
              "
              class="blue"
              @click="getcopyUrl(scope.row)"
            >
              <div class="cancel_agree">获取链接</div>
            </div>
            <!-- 债权转让             -->
             <!-- 获取链接 -->
             <div
              v-if="
                scope.row.applyStatus == '20'
              "
              class="blue"
              @click="perfectInfo(scope.row)"
            >
              <div class="cancel_agree">签署债转协议</div>
            </div>
            <!-- 获取债权转让通知签署链接 -->
           <!-- <div
              v-if="
                scope.row.applyStatus == '26' || scope.row.applyStatus == '14' && isNotificationAutomation 
              "
              class="blue"
              @click="QueryNoticeUrl(scope.row)"
              :style="{'pointer-events': isOfferDisabled}"
            >
              <div class="cancel_agree">签署债转通知书</div>
            </div> -->
            <div
              v-if="
                (scope.row.notificationStatus == '21' ||scope.row.applyStatus == '21' ||scope.row.applyStatus == '26' || scope.row.applyStatus == '28' || scope.row.applyStatus == '14') && isNotificationAutomation && !scope.row.zqtzsPath
              "
              class="blue"
              @click="QueryNoticeUrl(scope.row)"
              :style="{'pointer-events': isOfferDisabled}"              
            >
              <div class="cancel_agree">签署债转通知书</div>
            </div>
            <!-- <div
              class="blue"
              @click="repayment(scope.row)"
              :style="{'pointer-events': isOfferDisabled}"              
            >
              <div class="cancel_agree">还款开户</div>
            </div>
            <div
              class="blue"
              @click="entrust(scope.row)"
              :style="{'pointer-events': isOfferDisabled}"              
            >
              <div class="cancel_agree">签署委托协议</div>
            </div>
            <div
              class="blue"
              @click="withhold(scope.row)"
              :style="{'pointer-events': isOfferDisabled}"              
            >
              <div class="cancel_agree">还款代扣</div>
            </div> -->
            <div
            v-if=" ( scope.row.applyStatus == '14' || scope.row.applyStatus == '26') && scope.row.notificationStatus != '17' && $hasPermission('loan:transfer:terminateAnAgreement')"
            >
              <div class="resign_agree" @click="TerminateAnAgreement(scope.row)">重签债转协议</div>
            </div>
            <div v-if="(scope.row.applyStatus == '14' || scope.row.applyStatus == '26') && $hasPermission('loan:transfer:signClearanceCertificate')">
              <div class="clearance" @click="bb(scope.row)">开结清证明</div>
            </div>
            
            
          </template>
        </el-table-column>

        <el-table-column
          prop="loanApplyTime"
          label="协议"
          width="260"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="box-contract">
              <div>
                <div
                  v-if="
                    scope.row.filePath &&
                    $hasPermission('loan:tloanapply:contract')
                  "
                  class="blue"
                  @click="contractDownload(scope.row.filePath)"
                  target="_blank"
                >
                  <div class="agreement_btn">借款合同下载</div>
                </div>
                <div
                  v-if="
                    scope.row.unitePath &&
                    $hasPermission('loan:tloanapply:mortgageContract')
                  "
                  class="blue"
                  @click="contractDownload(scope.row.unitePath)"
                  target="_blank"
                >
                 <div class="agreement_btn">借款合同终止协议书下载</div>
                </div>
                <div
                  v-if="
                    !isSigningMethod &&
                    isXy({
                      url: scope.row.zqxyPath,
                      status: scope.row.applyStatus,
                      n: 1,
                    }) &&
                    $hasPermission('loan:tloanapply:agreement')
                  "
                  class="blue agreement"
                  @click="handleUploadDialog('债权转让方协议', scope.row, 1)"
                >
                  <div class="agreement_btn">
                    <span class="el-icon-upload"></span>债权转让协议
                  </div>
                </div>
                <div
                  v-else-if="
                    isSigningMethod &&
                    isXy({
                      url: scope.row.zqxyPath,
                      status: scope.row.applyStatus,
                      n: 1,
                    }) &&
                    $hasPermission('loan:tloanapply:agreement')
                  "
                  class="blue agreement"
                  @click="perfectInfo(scope.row)"
                >
                  <div class="agreement_btn">线上签署债权转让协议</div>
                </div>

                <div
                  v-if="
                    (scope.row.zqxyPath || scope.row.applyStatus == '14') &&
                    $hasPermission('loan:tloanapply:lookover')
                  "
                >
                  <div class="agreement_btn">
                    <a :href="scope.row.zqxyPath" target="_blank"
                    >债权转让协议下载</a
                  >
                  </div>
                </div>
                <div
                 v-if="
                   scope.row.zqxyCancelPath  &&
                   $hasPermission('loan:transfer:terminateAnAgreement')"
                >
                  <div class="agreement_btn">
                    <a :href="scope.row.zqxyCancelPath" target="_blank"
                   >终止债权转让协议下载</a>
                  </div>
                  
                 </div>

                <div
                  v-if="
                    !isNotificationMethod &&
                    isXy({
                      url: scope.row.zqtzsPath,
                      status: scope.row.applyStatus,
                      n: 2,
                    }) &&
                    $hasPermission('loan:tloanapply:advice')
                  "
                  class="blue agreement"
                  @click="handleUploadDialog('债权转让方通知书', scope.row, 2)"
                >
                  <div class="agreement_btn">
                    <span class="el-icon-upload"></span>上传债权转让通知书
                  </div>
                </div>
                <div
                  v-else-if="
                    $hasPermission('loan:tloanapply:advice') &&
                    isXy({
                      url: scope.row.zqtzsPath,
                      status: scope.row.applyStatus,
                      n: 1,
                    }) &&
                    isNotificationMethod
                  "
                  class="blue agreement"
                  @click="perfectInfo(scope.row)"
                >
                  <div class="agreement_btn">线上签署债权转让通知书</div>
                </div>
                <div
                  v-if="
                    scope.row.zqtzsPath &&
                    $hasPermission('loan:tloanapply:advicelookover')
                  "
                >
                  <div class="agreement_btn">
                    <a :href="scope.row.zqtzsPath" target="_blank"
                    >债权转让通知书下载</a
                  >
                  </div>
                  
                </div>
                <div class="agreement_btn" v-if="scope.row.jqxyPath">
                  <a :href="scope.row.jqxyPath" target="_blank"
                    >结清证明协议下载</a>
                </div>
              </div>
              <span
                v-if="scope.row.filePath"
                class="el-icon-star-on"
                :class="scope.row.applyStatus == '12' ? 'yellow' : ''"
              ></span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="loanAmount"
          label="回单"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="blue">
              <div
                v-if="
                  scope.row.nbdfPath && $hasPermission('loan:tloanapply:inside')
                "
                @click="contractDownload(scope.row.nbdfPath)"
              >
                <div class="agreement_btn">转账回单下载</div>
              </div>
              <div
                v-if="
                  scope.row.wbdfPath &&
                  $hasPermission('loan:tloanapply:external')
                "
                @click="contractDownload(scope.row.wbdfPath)"
              >
                <div class="agreement_btn">放贷回单下载</div>
              </div>
              <div
                v-if="
                  scope.row.mentPath && $hasPermission('loan:tloanapply:ment')
                "
                @click="contractDownload(scope.row.mentPath)"
              >
                <div class="agreement_btn">还款回单下载</div>
              </div>
              <div
                v-if="
                  scope.row.wthdrwRcptUrl && $hasPermission('loan:tloanapply:wthdrw')
                "
                @click="contractDownload(scope.row.wthdrwRcptUrl)"
              >
                <div class="agreement_btn">提现回单下载</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
      <add-or-updatee
        v-if="addOrUpdateCVisible"
        ref="addOrUpdatec"
        @signedFS="getDataList()"
        @refreshDataList="getDataList"
      ></add-or-updatee>
      <add-or-updateloan
        v-if="addOrUpdateCloanVisible"
        ref="addOrUpdatecloan"
        @iscodeFS="createPassword"
         @signedFS="getDataList()"
         :applyId="applyId"
      ></add-or-updateloan>
      <!-- 查看证件弹窗 -->
      <el-dialog
      :visible.sync="isLookIdNo">
      <div class="look-title" slot="title">
        <img src="../../../assets/img/证件.png" alt="">
        <span v-if="typeNum == 1">共借人证件</span>
        <span v-if="typeNum == 3">抵押共有人证件</span>
      </div>
        <div class="look-dialog">
          <div class="left-dialog">
            <div class="title">身份证头像面</div>
            <div class="idNO-img" v-for="(item,index) in InfoList" :key="index">
              <div class="img-box">
                <img :src="item.frontUrl" alt="">
              </div>
            </div>
          </div>
          <div class="right-dialog">
            <div class="title">身份证国徽面</div>
            <div class="idNO-img" v-for="(item,index) in InfoList" :key="index">
              <div class="img-box">
                <img :src="item.backUrl" alt="">
              </div>
            </div>
            
          </div>
        </div>
    </el-dialog>
      <!-- <el-dialog 
        :visible.sync="exportDialogVisible" 
        width="600px" 
        center
        class="custom-export-dialog"
      >
        <p class="dialog-text">导出文件生成中.......，请从“<b>下载管理</b>”页面下载文件</p>

        <span slot="footer" class="dialog-footer">
          <el-button @click="exportDialogVisible = false">稍后下载</el-button>
          <el-button type="primary" @click="goToDownloadPage">去下载</el-button>
        </span>
      </el-dialog> -->
      <el-dialog 
        :visible.sync="exportDialogVisible" 
        width="600px" 
        center
        class="custom-export-dialog"
      >
        <p class="dialog-text">导出文件生成中.......，请从“<b>下载管理</b>”页面下载文件</p>

        <span slot="footer" class="dialog-footer">
          <el-button @click="exportDialogVisible = false">稍后下载</el-button>
          <el-button type="primary" @click="goToDownloadPage">去下载</el-button>
        </span>
     </el-dialog>
      <!-- 完善信息 -->
      <perfect ref="perfect" @callbackfn="callbackfn"></perfect>

      <!-- 请输入支付密码 -->
      <el-card class="box-card1" v-show="isSHowPasswordControl">
        <p>中运交投</p>
        <p class="p2">请输入支付密码</p>

        <!-- HTML的标签用到的属性尽量不要动，如有需要调整样式，可自行增加class即可 -->
        <!-- 整个div会默认撑满父容器宽高，继承父容器颜色字体大小，点击元素会弹出密码键盘 -->
        <div class="passWord-box">
          <div id="ipt_pwd2" class="ipt_pwd">
            <span id="LOGPASS2_SHOW">请输入密码</span>
            <input
              id="LOGPASS2"
              class="default input_search"
              type="password"
              disabled="disabled"
            />
            <div id="keyboardBtn2" class="ipt_pwd_rjp default"></div>
          </div>
          <!-- <div id="ipt_pwd3" class="ipt_pwd">
              <span id="LOGPASS3_SHOW">请确认密码</span>
              <input id="LOGPASS3" class="default input_search" type="text" disabled="disabled" />
              <div id="keyboardBtn3" class="ipt_pwd_rjp default"></div>
            </div> -->
        </div>
        <div class="get-password-box">
          <el-button @click="getPassword('off')">取消支付</el-button>
          <el-button id="get-password" @click="getPassword('pay')" :disabled="zf"
            >确认支付</el-button
          >
        </div>
      </el-card>

      <!-- 签约 -->
      <el-card class="box-card" v-if="signed">
        <p>中运交投</p>
        <h3>请通过 短信中链接进行签约</h3>
        <ul>
          <li>
            <span>手机号 </span> <span>{{ signObj.mobile }}</span>
          </li>
          <li>
            <span>借款编号 </span> <span> {{ signObj.agreementCode }} </span>
          </li>
          <li>
            <span>签约有效时间 </span> <span> {{ lastDay }} </span>
          </li>
        </ul>
        <div class="card-btn">
          <button
            @click="
              () => {
                (signed = false), getDataList();
              }
            "
          >
            取消
          </button>
          <button @click="signedOK(signObj)">已签约去放款</button>
        </div>
      </el-card>

      <!-- 债权转让弹窗 -->
      <el-card class="box-card" v-if="isperfect">
        <p>中运交投</p>
        <h3>请通过 短信中链接进行债权转让签署</h3>
        <ul>
          <li>
            <span>手机号 </span>
            <span> {{ perfectInfoObj.creditorTelephone }} </span>
          </li>
          <li>
            <span>借款编号 </span> <span> {{ perfectObj.agreementCode }} </span>
          </li>
          <li>
            <span>签约有效时间 </span> <span> {{ lastDay }} </span>
          </li>
        </ul>
        <div class="card-btn">
          <button
            @click="
              () => {
                (isperfect = false), getDataList();
              }
            "
           
          >
            取消
          </button>
         
          <button @click="sendPerfect"  :disabled="isdisabled">
          <template v-if="isdisabled">
            <i class="el-icon-loading"></i>
          </template>
          <template v-else>
            确认
              
          </template>
          </button>
        </div>
      </el-card>

      <!-- 解约 -->
      <el-card class="box-card" v-if="cancel">
        <p>中运交投</p>
        <h3>请通过 短信中链接进行解约</h3>
        <ul>
          <li>
            <span>手机号 </span>
            <div class="mobile-box">
              <span v-for="item in cancelObj.mobile" :key="item">{{
                item
              }}</span>
            </div>
          </li>
          <li>
            <span> 借款合同编号 </span>
            <span> {{ signObj.agreementCode }} </span>
          </li>
          <li v-if="cancelObj.mortgageCode">
            <span> 抵押合同编号 </span>
            <span> {{ cancelObj.mortgageCode }} </span>
          </li>
          <li>
            <span> 签约有效时间 </span> <span> {{ lastDay }} </span>
          </li>
        </ul>
        <div class="card-btn">
          <button
            @click="
              () => {
                (cancel = false), getDataList();
              }
            "
          >
            取消
          </button>

          <button
            @click="
              () => {
                (cancel = false), getDataList();
              }
            "
          >
            确定
          </button>
        </div>
      </el-card>
      <!-- 签署债转通知书 -->
      <el-card class="box-card" v-if="isButtonDisabled">
        <p>中运交投</p>
        <h3>请点击手机短信中链接进行签约</h3>
        <ul>
          <li>
            <span>手机号 </span> <span>{{ offerObj.mobile }}</span>
          </li>
          <li>
            <span>借款编号 </span> <span> {{ offerObj.agreementCode }} </span>
          </li>
          <li>
            <span>链接有效截止时间 </span> <span> {{ lastDay }} </span>
          </li>
        </ul>
        <div class="card-btn">
          <button
            @click="
              () => {
                (isButtonDisabled = false), getDataList();
              }
            "
          >
            取消
          </button>
          <button
          @click="
              () => {
                (isButtonDisabled = false), getDataList();
              }
            "
          >确定</button>
        </div>
      </el-card>

        <!-- 获取链接 -->
        <el-card class="box-card" v-if="copyUrlStatus">
        <p>中运交投</p>
        <h3>{{copytitle}}合同签署链接</h3>
        <div style="min-height: 60px;">
          {{ copyUrl }}
        </div>
        
        <div class="card-btn">
          <button
            @click="
              () => {
                (copyUrlStatus = false)
              }
            "
          >
            取消
          </button>
          <button  class="copybox" :data-clipboard-text="copyUrl" @click="copy">复制
          </button>
         
        </div>
      </el-card>
      <!-- 还款开户 -->
      <!-- <el-dialog :visible.sync="repaymentVisible" width="600px">
        <div>请复制以下开户链接提供给借款人进行开户：</div>
        <div class="copy_link">{{ repaymentUrl }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="repaymentVisible = false"> 取 消 </el-button>
          <el-button type="primary" class="copybox" :data-clipboard-text="repaymentUrl"  @click="copy()"> 复 制 </el-button>
        </span>
      </el-dialog> -->
      <!-- 签署委托协议 -->
      <!-- <el-dialog :visible.sync="entrustVisible" width="600px">
        <div>请复制以下签署委托协议链接提供给借款人进行免密授权：</div>
        <div class="copy_link">{{ entrustUrl }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="entrustVisible = false"> 取 消 </el-button>
          <el-button type="primary" class="copybox" :data-clipboard-text="entrustUrl" @click="copy()"> 复 制 </el-button>
        </span>
      </el-dialog> -->
      <!-- 还款代扣 -->
      <!-- <el-dialog :visible.sync="withholdVisible" width="600px">
        <div class="withhold_box">
          <div>还款代扣金额（元）</div>
          <el-input v-model="withholdAmount" placeholder="请输入金额"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="withholdVisible = false"> 取 消 </el-button>
          <el-button type="primary" @click="withholdConfirm()"> 确 定 </el-button>
        </span>
      </el-dialog> -->

      <!-- 上传的弹窗 -->
      <el-dialog
        :title="dialogStr + '上传'"
        v-if="uploadDialogVisible"
        :visible.sync="uploadDialogVisible"
        :destroy-on-close="true"
        width="30%"
        :before-close="handleClose"
      >
        <el-upload
          class="upload-demo"
          :limit="1"
          accept=".pdf"
          drag
          :action="actionUrl"
          :data="{ applyId: curRowObj.id, type: num }"
          :on-success="successHandle"
          @on-remove="beforeRemoveFile"
          :on-preview="handlePdfPreview"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传PDF文件，且不超过500kb
          </div>
        </el-upload>

        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadDialogVisible = false"> 取 消 </el-button>
          <el-button type="primary" @click="upOk()"> 确 定 </el-button>
        </span>
      </el-dialog>

      <!-- 文件预览 -->
      <el-dialog :visible.sync="dialogVisible">
        <div></div>
        <!-- <img width="100%" :src="previewPdfUrl" /> -->
        <Pdf :src="previewPdfUrl" ref="pdf"></Pdf>
      </el-dialog>
    </div>
    <el-card class="box-yzm" v-if="isyzm">
      <p>中运交投</p>
      <p class="p2">请输入验证码({{ $store.state.info.mobile }})</p>
      <div>
        <div class="input-box">
          <div
            class="code-item"
            :class="
              codeValue.length == 0 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[0] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 1 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[1] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 2 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[2] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 3 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[3] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length == 4 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[4] }}
          </div>
          <div
            class="code-item"
            :class="
              codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''
            "
          >
            {{ codeValue[5] }}
          </div>
          <input
            class="input-code"
            v-model="codeValue"
            :maxlength="6"
            type="tel"
            @blur="codeInputBlur"
            @focus="codeInputFocus"
            @input="codeInputChange"
          />
        </div>
      </div>
      <div class="footer-btn">
        <el-button
          @click="
            () => {
              (isyzm = false), (codeValue = ''), getDataList();
            }
          "
          >取消</el-button
        >
        <el-button @click="yzm()">确认</el-button>
      </div>
    </el-card>
    <el-dialog
      title="录入公证"
      :visible.sync="notarizationVisible"
      width="500px"
    >
    <el-form   
        :model="dataForm1"
        label-width="120px"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="资金方">
          <div>{{dataForm1.deptName}}</div>
        </el-form-item>
        <el-form-item label="借款人">
          <div>{{dataForm1.custName}}</div>
        </el-form-item>
        <el-form-item label="公证日期" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <el-date-picker
            v-model="dataForm1.dateTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notarizationVisible = false">取 消</el-button>
        <el-button type="primary" @click="notarizationConfirm()">提 交</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./tloanapply-add-or-update";
import AddOrUpdateloan from "./tloanapply-add-or-updateloan";
import AddOrUpdatee from "./tloanapply-add-or-updatee";
import perfect from "./tloanapply-add-or-perfect.vue";
import Cookies from "js-cookie";
import Pdf from "vue-pdf";
import { getCancelInfo } from "../../../api/api";
import Clipboard from 'clipboard';
import { create } from "lodash";
export default {
  mixins: [mixinViewModule],

  

  data() {
    return {
      payMethodId: '0',
      maxHeight:'600',
      dataForm1:{
        deptName:'',
        applyId: '',
        userId:'',
        custName:'',
        dateTime:'',
      },
      exportDialogVisible: false,
      isExporting: false,
      itemData:{},
      zf: false,
      notarizationVisible:false,
      typeNum:null,
      isJieqing:false,
      isClick:false,
      InfoList:[],
      isLookIdNo:false,
      num: 1,
      lastDay: "",
      yzmData: {},
      copyUrlStatus: false, //获取链接弹窗
      copyUrl: '', //要复制的url
      copytitle: '',
      isperfect: false,
      isNotificationMethod: true, // 默认线上
      isNotificationAutomation:false,
      isSigningMethod: true, // 默认线上
      isyzm: false,
      codeValue: "",
      applyId: "",
      isSHowPasswordControl: false,
      passwordInstance: "",
      perfectObj: {},
      isButtonDisabled: false,
      isOfferDisabled:'normal',
      perfectInfoObj: {},
      isDisabled: false,
      options: {
        // "map_arr": "Wyc0MycsICc1NycsICc3MScsICcxMjEnLCAnMTI2JywgJzEyNCcsICc5MCcsICcxMTInLCAnODknLCAnOTMnLCAnMTA1JywgJzgxJywgJzExMycsICcxMjUnLCAnNjgnLCAnMzgnLCAnODUnLCAnNjUnLCAnMTE4JywgJzgwJywgJzg3JywgJzkxJywgJzQ0JywgJzMzJywgJzc4JywgJzg4JywgJzk2JywgJzEwOScsICc2MScsICc2NicsICc0MCcsICc4MicsICc3MicsICcxMjAnLCAnOTUnLCAnMTEwJywgJzQ2JywgJzg2JywgJzEwNycsICc1MCcsICc3MCcsICc5OCcsICcxMTcnLCAnMzYnLCAnMTAxJywgJzgzJywgJzQ4JywgJzExNCcsICc2NycsICc3NycsICcxMDgnLCAnMTAwJywgJzM1JywgJzczJywgJzY5JywgJzk5JywgJzEwMicsICc3NicsICc3NScsICcxMDQnLCAnNDknLCAnOTInLCAnNjInLCAnNTgnLCAnNTMnLCAnNzknLCAnOTcnLCAnNDUnLCAnNDEnLCAnMTE5JywgJzEyMycsICc1MScsICc2MycsICc0NycsICcxMDYnLCAnMzknLCAnMTExJywgJzExNScsICczNCcsICc5NCcsICcxMjInLCAnNjQnLCAnNTknLCAnMTE2JywgJzM3JywgJzc0JywgJzU1JywgJzYwJywgJzU0JywgJzUyJywgJzQyJywgJzg0JywgJzEwMycsICc1Nidd",
        // "license":"UjNpRHFyYWhSYzk5R1AzcTBCb1ZucURyLzhpekNiN1dGYkRWM1A3NjlnSzZnK0VZMDVzeno3akYrYS84VlR4UHhxRkFJRjJmeWdWKzJsU1hTV2hNMzg5WTBpbFk0bGhzU01GcXQvOTcyQmZ4akNtUXlrNEpMVnk0OXR0eXhRZ3RpYmFIMXkxcHg5UDZIbnBweG8rbGZqcS9Yekh1VGJ1K3kyZnBFS3didC9nPXsiaWQiOjAsInR5cGUiOiJ0ZXN0IiwicGxhdGZvcm0iOjEwLCJub3RiZWZvcmUiOiIyMDIyMDUzMCIsIm5vdGFmdGVyIjoiMjAyMjExMzAifQ==",
        // "oid_partner":"2020042904425468",
        // "random_key":"241a606e-a4ff-49f4-b102-882b61b36bdf",
        // "random_value":"63000403063155227830323742731688",
        // "ret_code":"0000",
        // "ret_msg":"交易成功",
        // "rsa_public_content":"308189028181009017e40c4b053ef663903066618131e705a91641441d8bc5de082a12147559dcbc790e7b85a0e42a388effa2b7d0c5f734733ef14869fb735b5245bda1d79e32c35004288190e080f8abe8ae7c8f2ff81738c1c32d6e944be7ad1197cb1d8c76455d6da8d623a0513647f5a59d1e9aa6ca077f136040b550ad411728455bf6230203010001",
        // "sm2_key_hex":"1093A047C5CBF48283EC7A210703F3FF9EA4448DC15D56B4CD82FCB27DAD2D45F2BB0BF953BCEBB635D9D34E473ECEFC9F25880EB1669F94DE050A29AC86F308",
        // "user_id":"2021060401291390051"
      },
      id: "",
      actionUrl: `${window.SITE_CONFIG["apiURL"]}/sys/oss/upload?token=${Cookies.get("token")}`,
      // actionUrl: `${window.SITE_CONFIG["apiURL"]}/sys/oss/upload`,
      dialogStr: "",
      previewPdfUrl: "",
      code: false,
      time: 0,
      codeValue: "",
      inputFocus: false,
      addOrUpdateCVisible: false,
      signed: false,
      cancel: false,
      addOrUpdateCloanVisible: false, //放款确认
      uploadDialogVisible: false,
      dialogVisible: false,
      repaymentVisible:false,
      entrustVisible: false,
      withholdVisible: false,
      repaymentUrl:'',
      entrustUrl:'',
      withholdAmount:'',
      mixinViewModuleOptions: {
        getDataListURL: "/loan/tloanapply/page",
        getDataListIsPage: true,
        exportURL: "/loan/tloanapply/export",
        deleteURL: "/loan/tloanapply",
        deleteIsBatch: true,
      },
      userType: [],
      date:null,
      date1:null,
      dataForm: {
        mobile: '',
        companyId: '',
        agreementCode: '',
        lendingStatus: '',
        applyStatus:'',
      },
      channelList:[],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); 
          const selectedDay = new Date(time);
          selectedDay.setHours(0, 0, 0, 0);
          return selectedDay > today;
        }
      },
      applyStatusList:[
        {
          value: '0',
          label: '失败'
        },
        {
          value: '1',
          label: '放款成功',
        },
        {
          value: '2',
          label: '待签约'
        },
        {
          value: '3',
          label: '借款协议签署中'
        },
        {
          value: '4',
          label: '待放款'
        },
        {
          value: '5',
          label: '放款失败'
        },
        {
          value: '6',
          label: '提现中'
        },
        {
          value: '7',
          label: '取消'
        },
        {
          value: '8',
          label: '退回'
        },
        {
          value: '9',
          label: '退回失败'
        },
        {
          value: '10',
          label: '放款中'
        },
        {
          value: '11',
          label: '借款合同解约中'
        },
        {
          value: '12',
          label: '已解约'
        },
        {
          value: '13',
          label: '债权转让签署中'
        },
        {
          value: '14',
          label: '债权转让签署成功'
        },
        {
          value: '15',
          label: '债权转让签署失败'
        },
        {
          value: '16',
          label: '债权转让通知书签署中'
        },
        {
          value: '17',
          label: '债权转让完成'
        },
        {
          value: '18',
          label: '贷款协议链接失效'
        },
        {
          value: '19',
          label: '借款解约链接失效'
        },
        {
          value: '20',
          label: '债权转让链接失效'
        },
        {
          value: '21',
          label: '债权转让通知书链接失效'
        },
        {
          value: '22',
          label: '债权转让通知书签署失败'
        },
        {
          value: '23',
          label: '债转解约签署中'
        },
        {
          value: '24',
          label: '债转解约成功'
        },
        {
          value: '25',
          label: '重签债权转让签署中'
        },
        {
          value: '26',
          label: '重签债转成功'
        },
        {
          value: '27',
          label: '结清证明签署中'
        },
        {
          value: '28',
          label: '已结清'
        },
        {
          value: '29',
          label: '待债转'
        },
        {
          value: '30',
          label: '债权转让签约失败'
        },
        {
          value: '31',
          label: '重签债转协议失败'
        },
        {
          value: '32',
          label: '结清证明签署失败'
        },
        {
          value: '33',
          label: '提现失败'
        },
      ],
      loanStatusList: [
        {
          value: '4',
          label: '待放款'
        },
        {
          value: '10',
          label: '放款中',
        },
        {
          value: '1',
          label: '放款成功',
        },
        {
          value: '5',
          label: '放款失败',
        },
        {
          value: '8',
          label: '退回成功',
        },
        {
          value: '9',
          label: '退回失败',
        },
      ],
      curRowObj: {
        id: '',
      },
      signObj: {},
      cancelObj: {},
      offerObj:{},
    };
  },
  mounted() {
    this.getInformation();
  },
  watch: {
    $route: {
      handler(newVal, odlVal) {
        if (newVal.path === "/loan-tloanapply") {
          this.getPerfectInfo();
          if (newVal.query.data) {
            this.dataForm.mobile = newVal.query ? newVal.query.data : "";
            this.getDataList(this.dataForm.mobile);
          } else {
            this.dataForm.companyId = "";
            this.dataForm.mobile = "";
            if (this.$refs.tree) {
              this.$refs.tree.showDeptName = "";
            }
            this.getDataList();
          }
        } else {
          this.dataForm.mobile = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.calculateTableMaxHeight();
    window.addEventListener('resize', this.calculateTableMaxHeight);
    this.$http.get(`/sys/dict/data/list?dataType=pay_channel`).then(r=>{
        this.channelList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
  },
  mounted() {
    this.getFactor();
    
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableMaxHeight);
  },
  methods: {
    calculateTableMaxHeight() {
      // 获取窗口宽度和高度
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const devicePixelRatio = window.devicePixelRatio;
      console.log(1212,devicePixelRatio);
      
      // 根据分辨率设置不同的 max-height
      if (windowWidth <= 1920) {
        this.maxHeight = 700 / devicePixelRatio;
      } else if (windowWidth >= 2560) {
        this.maxHeight = 920 / devicePixelRatio;
      } else {
        // 默认高度或其他分辨率下的高度
        this.maxHeight = 800 / devicePixelRatio;
      }
    },
    // 录入公证
    notarization(item){
      this.itemData = item
      this.notarizationVisible = true
      this.$http.get(`/loan/transfer/loanNoVestIn/${item.id}`).then(res=>{
        this.dataForm1 = res.data.data
      })
    },
    notarizationConfirm(){
      if(!this.dataForm1.dateTime){
        this.$message.error('请选择日期')
        return
      }
      this.$http.post(`/loan/transfer/notarization`,this.dataForm1).then(res=>{
        if(res.data.code == 0){
          this.$message.success(res.data.msg)
          this.notarizationVisible = false
          this.getDataList()
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startDate = this.date[0]
          this.dataForm.endDate = this.date[1]
          console.log(33,this.dataForm);
        }else{
          delete this.dataForm.startDate
          delete this.dataForm.endDate
        }
    },
    getTimes1() {
        if (this.date1 != null) {
          this.dataForm.loanTimeStart = this.date1[0]
          this.dataForm.loanTimeEnd = this.date1[1]
        }else{
          delete this.dataForm.loanTimeStart
          delete this.dataForm.loanTimeEnd
        }
    },
  //终止债转协议
      TerminateAnAgreement(row){
        console.log(222,row.applyStatus);
        if (this.isClick == true) {
          this.$message.error('已在签署通知书，不可再重新债转')
        }else{
          this.$http
        .get(`/loan/transfer/terminateAnAgreement/${row.id}`)
        .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            }
            this.$message({
             message: this.$t("prompt.success"),
            type: "success",
            duration: 500,
         });
        }).catch(() => {}).finally(() => {
          this.isdisabled = false
          this.isperfect = false;
          this.getDataList()
         })
        }
        
    },
    // 查看证件
    lookIdNo(item,type){
      this.typeNum = type
      this.$http.get(`/api/loan/sign/showCommonBorrow?id=${item.id}&type=${type}`).then((res) => {
          console.log(23,res);
          this.InfoList = res.data.data
          if(res.data.code == 500){
            this.$message.error(res.data.msg)
          }else{
            if(res.data.data[0].frontUrl != null){
            this.isLookIdNo = true
          }else{
            this.$message.error('暂未上传身份证照片')
          }
          }
          
          
      })
    },
    btn(){
      console.log(111111);
    },
    copy() {
				let clipboard = new Clipboard('.copybox')
        
				clipboard.on('success', e => {
					console.log('复制成功')
          this.$message.success('复制成功')
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					// 不支持复制
          this.$message.error('该浏览器不支持自动复制')
					console.log('该浏览器不支持自动复制')
					// 释放内存
					clipboard.destroy()
				})
        this.copyUrlStatus = false
        this.repaymentVisible = false
        this.entrustVisible = false
		},
    
      // 获取要签约的链接
    getcopyUrl(row){
      if(this.copyUrlStatus) return;
      if(row.applyStatus == '3'){
        this.copytitle = '签约'
        this.copyUrl = row.signFlowUrl;
      } 
      if(row.applyStatus == '13'){
        this.copytitle = '债权转让'
        this.copyUrl = row.transferUrl;
      } 
      if(row.applyStatus == '16'){
        this.copytitle = '债权转让通知书'
        this.copyUrl = row.noticeUrl;
      }
      if(row.applyStatus == '11'){
        this.copytitle = '解约'
        this.copyUrl = row.uniteUrl;
      }  
      this.copyUrlStatus = true
     
    },
    // 转让协议弹窗
    callbackfn() {
      this.getInformation();
      this.$nextTick(() => {
        this.isperfect = true;
      });
    },


    getPerfectInfo() {
      this.$http.get("/loan/transfer/signingMethod").then(({ data: res }) => {
        console.log(res);
        if (res.code != 0) {
          this.$message.error(res.msg);
          return;
        }
        if (res.data.notificationMethod == "线下")
          this.isNotificationMethod = false;
        if (res.data.signingMethod == "线下") this.isSigningMethod = false;
        if (
          res.data.notificationMethod == "线上" ||
          !res.data.notificationMethod
        )
          this.isNotificationMethod = true;
        if (res.data.signingMethod == "线上" || !res.data.signingMethod)
          this.isSigningMethod = true;
        if(res.data.notificationMethod == '线上手动') this.isNotificationAutomation = true
      });
    },
    //完善信息弹窗
    perfectInfo(row) {
      // 获取时间
      this.setTime(1);
      this.perfectObj = row;
      this.$http
        .post("/loan/transfer/signMessageVerify")
        .then(({ data: res }) => {
          if (res.code == 0) this.isperfect = true;
          if (res.code == 500) this.$refs.perfect.visible = true;
          if (res.code != 500 && res.code != 0) {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {});
    },
    //获取完善信息弹窗
    getInformation() {
      this.$http
        .post("/loan/transfer/signMessageReturn")
        .then(({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
            return;
          }
          this.perfectInfoObj = res.data ? res.data : {};
        });
    },
    // 发送线上转让协议短信点击确认按钮
    sendPerfect() {
      if(this.isdisabled) return;
      this.isdisabled = true
      this.$http
        .get(`/loan/transfer/${this.perfectObj.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$message({
            message: this.$t("prompt.success"),
            type: "success",
            duration: 500,
          });
        })
        .catch(() => {}).finally(() => {
          this.isdisabled = false
          this.isperfect = false;
          this.getDataList()
        })

      
    },
    // 结清证明
    bb(row){
      //处理点击事件逻辑
     
      if(this.isJieqing == false){
        this.isJieqing = true
        this.$http
        .get(`loan/transfer/signClearanceCertificate/${row.id}`)
        .then(({ data: res }) => {
         //关闭
          // loadingInstance.close();
        if (res.code != 0) {
          this.$message.error(res.msg);
        }else{
          this.$message.success(res.msg);
        }
        }).finally(()=>{
          this.getDataList()
          this.isJieqing = false
        })
      }else{
        this.$message.error('正在生成中,请勿重复操作');
      }
      
    },
    // 还款开户
    repayment(row){
      console.log(231,row);
      this.$http.get(`/api/account/openAccount/${row.custId}`)
        .then(({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
          }else{
            this.repaymentUrl = res.data
            this.repaymentVisible = true

          }
        })
      
    },
    // 签署委托协议
    entrust(row){
      
      this.$http.post(`/api/agree/agreeApply`,{
        userId:row.custId
      }).then(({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
          }else{
            this.entrustUrl = res.data.gateway_url
            this.entrustVisible = true

          }
        })
    
    },
    // 还款代扣
    withhold(row){
      this.applyId = row.id
      this.withholdVisible = true
    },
    withholdConfirm(){
      this.$http.post(`/api/trans/mentPay`,{
        totalAmount:this.withholdAmount,
        applyId:this.applyId
      }).then(({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
          }else{
            this.$message.success(res.msg)
            this.withholdVisible = false

          }
      })
    },
    // 获取债权转让通知书
    QueryNoticeUrl(row){
      this.isClick = true
     if(this.isButtonDisabled) return;
      //处理点击事件逻辑
      this.setTime();
      this.isButtonDisabled=true
      this.isOfferDisabled = 'none'
      console.log(12212,row);
      this.offerObj = row
      // // 打开提示框
      // const loadingInstance = this.$loading({
      //   lock: true,
      //   text: '正在加载,预计60s...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
        this.$http
        .get(`/loan/sign/notice/${row.id}`)
        .then(({ data: res }) => {
          //关闭
          // loadingInstance.close();
          if (res.code != 0) {
            this.$message.error(res.msg);
          }else{
            this.$message.success(res.msg);
          }
        }).finally(()=>{
          this.isOfferDisabled = 'normal'
          this.getDataList()
          this.isClick = false
        })

        // .catch(()=>{
        //   //关闭
        //   loadingInstance.close();
        // }).finally(()=>{
        //   this.isButtonDisabled = false;
        //   this.dataForm ={};
        //   this.getDataList();
        // })
    },

    getFactor(fn = () => {}) {
      this.$http.get("/api/trans/getRandom").then((r) => {
        if (r.data.code == "0") {
          // console.log(r.data.data);
          this.options = r.data.data;
          this.passwordInstance = this.initPassword(this.options);
          fn();
        } else {
          this.$message({
            type: "error",
            message: "获取随机因子失败",
          });
        }
      });
    },
    // 时间
    setTime(s = 0) {
      let t;
      if (s) {
        t = new Date().getTime();
      } else {
        t = new Date().getTime() + 24 * 60 * 60 * 1000; //24小时 * 60分钟 * 60秒 * 1000
      }

      let d = new Date(t);
      let theMonth = d.getMonth() + 1;
      let theDate = d.getDate();
      let theHours = d.getHours();
      let theMinutes = d.getMinutes();
     
      if (theMonth < 10) {
        theMonth = "0" + theMonth;
      }
      if (theDate < 10) {
        theDate = "0" + theDate;
      }
      if (theHours < 10) {
        theHours = "0" + theHours;
      }
      if (theMinutes < 10) {
        theMinutes = "0" + theMinutes;
      }
      let date = d.getFullYear() + "-" + theMonth + "-" + theDate;
      let time = theHours + ":" + theMinutes;
      let Spare = date + " " + time;
      this.lastDay = Spare;
    },
    isXy(obj) {
      // console.log(obj.status, obj.n);
      //n == 1 线下判断
      if (obj.n == 1) {
        if (!obj.url && obj.status == "1") {
          return true;
        } else {
          return false;
        }
      } else {
        //n == 2 线上判断
        if (!obj.url && (obj.status == "1" || obj.status == "14" || obj.status == "26")) {
          return true;
        } else {
          return false;
        }
      }
    },
    upOk() {
      this.uploadDialogVisible = false;
      this.getDataList();
    },
    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 4) {
        // do soming...
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },

    // 状态
    applyStatus(status, n) {
      if (n == "2") {
        if (status == "0" || status == "2" || status == "18") {
          return true;
        }
      } else {
        if (status == "4" || status == "5" || status == "19" || status == "20" || status == "21") {
          return true;
        }
      }

      return false;
    },
    createPassword(payMethodId) {
      this.payMethodId = payMethodId;
      
      this.getFactor(() => {
        this.isSHowPasswordControl = true;
      });
    },
    initPassword(options = {}) {
      // eslint-disable-next-line
      const passowrd = new showKeyBord({
        png: "//mpay-static.oss-cn-hangzhou.aliyuncs.com/html/lib/state-secret/img", // 图片路径，用这个就行了，也可以下载到本地
        click_objId: "#keyboardBtn2", // 触发显示键盘的Dom节点Id
        regExp1: "[\\S\\s]", // 输入过程限制的正则，不匹配正则的字符不让输入
        regExp2: "^[\\S\\s]{6,12}$", // 输入完成后的正则，与getValid()对应，判断输入值是否匹配该正则
        Input_texId: "#LOGPASS2", // 接收内容的Dom节点Id
        parent_objId: "#ipt_pwd2", // 将键盘插入到何处的Dom节点Id
        placeholderId: "#LOGPASS2_SHOW", // span标签的id，该span用于模拟Input_texId的placeholder
        len: "12", // 表示最大允许输入多少个字符[可以不传递]
        keyBordLeft: "",
        keyBordTop: "",
        chaosMode: 0, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        clickStatus: 0, // 按键状态,0:鼠标划过、悬浮时按键无变化;1:鼠标划过、悬浮时按键的颜色变化,默认值0
        titlefont: "安全支付输入",
        backfont: "退 格",
        capsfont: "切换大/小写",
        surefont: "确定",
        isen: false,
        callBack: () => {}, // 密码校验成功回调
        errorCallBack: () => {}, // 密码校验失败回调
        rsaPublicKey: options.rsa_public_content, // RSA加密必须参数，国密加密可不要
        sm2KeyHex: options.sm2_key_hex, // 国密加密必须参数，RSA加密可不要
        license: options.license, // 必须参数
      });
      passowrd.initOptions();
      return passowrd;
    },

    getPassword(r) {
      if (r == "off") {
        this.isSHowPasswordControl = false;
        this.passwordInstance.clearPWD();
        return;
      }
      this.zf = true;
      this.passwordInstance.setRandKey(this.options.random_value); // 先设置随机key

      const password = this.passwordInstance.getOutputSM(); // 国密加密密码

      const rsaPassword = this.passwordInstance.getOutput(); // RSA加密密码
      // hash用于比对密码是否一致，同一个密码加密密文可能不同，hash一定相同
      const hash = this.passwordInstance.getHash(); // RSA加密密码

      this.$http
        .post("/api/trans/transfer", {
          applyId: this.applyId,
          password: password,
          postscript: "暂无说明",
          randomKey: this.options.random_key,
          payChannelId:this.payMethodId,
        })
        .then((r) => {
          this.zf = false;
          if(r.data.code == 500){
            this.$message({
              type: "error",
              message: r.data.msg,
            });
            return
          }
          let data = r.data.data;

          if (data.ret_code == "0000") {
            this.passwordInstance.clearPWD();
            this.isSHowPasswordControl = false;
            this.$message({
              type: "success",
              message: data.ret_msg,
            });
          } else if (data.ret_code == "8888") {
            this.yzmData = data;
            this.$message({
              type: "warning",
              message: "请输入验证码",
            });
            this.passwordInstance.clearPWD();
            this.isSHowPasswordControl = false;
            this.isyzm = true;
          } else {
            this.$message({
              type: "error",
              message: data.ret_msg,
            });
            this.passwordInstance.clearPWD();
            this.isSHowPasswordControl = false;
          }
          this.getDataList();
          this.getFactor();
        }).catch((e) => {
          this.zf = false;
        });
      // const hash2 = this.passwordInstance2.getHash() // RSA加密密码
      // console.log("确认密码HASH是", hash2)
    },
    yzm() {
      this.$http
        .post("/api/trans/validationSms", {
          applyId: this.signObj.id,
          token: this.yzmData.token,
          totalAmount: this.yzmData.total_amount,
          verifyCode: this.codeValue,
          txnSeqno: this.yzmData.txn_seqno,
          postscript: "交易明细",
        })
        .then((r) => {
          if (r.data.data.ret_code == "0000") {
            this.$message({
              type: "success",
              message: r.data.data.ret_msg,
            });
            this.codeValue = "";
            this.isyzm = false;
          } else {
            this.$message({
              type: "error",
              message: r.data.data.ret_msg,
            });
          }
          setTimeout(() => {
            this.getDataList();
            this.getFactor();
          }, 500);
          
        });
    },
    handleClose() {
      this.uploadDialogVisible = false;
    },

    handleUploadDialog(str, row, n) {
      console.log(row, "rworoworwo");
      this.num = n;
      this.dialogStr = str;
      this.curRowObj = row;
      this.actionUrl = `${
        window.SITE_CONFIG["apiURL"]
      }/loan/tloanapply/upload?type=${n}&applyId=${row.id}&token=${Cookies.get(
        "token"
      )}`;
      this.uploadDialogVisible = true;
    },

    beforeRemoveFile(file, fileList) {
      console.log("文件移除操作", file);
    },

    handlePdfPreview(file) {
      console.log(file);
      this.previewName = file.name;
      this.previewPdfUrl = file.url || file.response.data;
      window.open(this.previewPdfUrl);
      // this.dialogVisible = true
    },

    // 上传成功
    successHandle(res, file, fileList) {
      console.log(file);
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      this.$message({
        message: this.$t("prompt.success"),
        type: "success",
        duration: 2000,
      });
    },

    ifadult(row) {
      let flag = true;
      console.log(3434,row);
      // if(row.coBorrowerIdCard){
      //   for (let arr = 0; arr < row.coBorrowerIdCard.length; arr++) {
      //     if (!this.analyzeIDCard(row.coBorrowerIdCard[arr]) && row.borrowerType == 'PERSONAGE') {
      //       flag = false;
      //       this.$message({
      //         type: "error",
      //         message: "暂不支持未成年签署",
      //       });
      //       return flag;
      //     }
      //   }
      // }
      // if(row.mortGaGerId){
      //   for (let arr = 0; arr < row.mortGaGerId.length; arr++) {
      //     if (!this.analyzeIDCard(row.mortGaGerId[arr]) && row.borrowerType == 'PERSONAGE') {
      //       flag = false;
      //       this.$message({
      //         type: "error",
      //         message: "暂不支持未成年签署",
      //       });
      //       return flag;
      //     }
      //   }
      // }
      return flag;
    },
    // 签约 解约
    async sign(row, n) {
      // console.log(row.coBorrowerIdCard.push(row.idNo))
      // console.log(11,row,n)
      this.setTime();
      if (n == 2) {
        if (row !== "edit") {
          this.signObj = row;
        }
        console.log(5555,row);
        
        if(this.signed) return;
        if (this.ifadult(row)) {
          this.$http.get("/loan/sign/" + row.id).then((r) => {
            if (r.data.code != 0) {
              this.$message({
                type: "error",
                message: r.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: r.data.msg,
              });
            }
          });
          this.id = row.custId;
          this.signed = true;
        }
      } else {
        let res = await getCancelInfo(row.id);
        console.log(res.data);

        if (res.data.code == 0) {
          this.cancelObj = res.data.data;
          this.$http.get("/loan/untie/" + row.id).then((r) => {
            if (r.data.code != 0) {
              this.$message({
                type: "error",
                message: r.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: r.data.msg,
              });
            }
          });
          this.signObj = row;
          this.cancel = true;
        } else {
          this.$message({
            type: "error",
            message: r.data.msg,
          });
        }
      }
    },
    analyzeIDCard(IDCard) {
      //获取用户身份证号码
      var userCard = IDCard;

      //如果身份证号码为undefind则返回空
      if (!userCard) {
        return false;
      }
      //获取出生年月日
      var yearBirth = userCard.substring(6, 10);
      var monthBirth = userCard.substring(10, 12);
      var dayBirth = userCard.substring(12, 14);
      console.log(yearBirth, monthBirth, dayBirth);

      //获取当前年月日并计算年龄
      var myDate = new Date();
      var monthNow = myDate.getMonth() + 1;
      var dayNow = myDate.getDate();
      var age = myDate.getFullYear() - yearBirth;
      if (
        monthNow < monthBirth ||
        (monthNow == monthBirth && dayNow < dayBirth)
      ) {
        age--;
      }
      if (age >= 18) {
        // this.$message({
        //   type:'success',
        //   message:'18'
        // })
        return true;
      }
      //  this.$message({
      //     type:'error',
      //     message:'15'
      //   })
      return false;
    },
    // 修款借款记录
    elitRecord(row = false) {
      if (row) {
        this.signObj = row;
      }
      this.signed = false;
      this.addOrUpdateCVisible = true;
      this.$nextTick(() => {
        if (row) {
          this.$refs.addOrUpdatec.examine = false;
        } else {
          this.$refs.addOrUpdatec.examine = true;
        }
        this.$refs.addOrUpdatec.infoid = this.signObj;
        this.$refs.addOrUpdatec.getFormData(this.signObj);
        this.$refs.addOrUpdatec.dialogVisible = true;
      });
    },
    goToUrl(params) {
      const routeUrl = this.$router.resolve({
        path: "/loanok",
        query: params,
      });

      window.open(routeUrl.href, "_blank");
    },
    // 合同下载
    contractDownload(url) {
      // const link = window.document.createElement("a"); // 创建a标签
      // link.href = url;
      // link.download = "receipt.zip";
      // link.style.display = "none";
      // link.click();
      window.open(url);
    },
    // 回单下载
    receiptFound(params) {
      this.$http.post("/api/receipt/receiptDownload", params).then((res) => {
        // let blob = new Blob([res.data], { type: 'application/zip' }); //设置下载的内容以及格式
        // console.log(blob)
        // const url = window.URL.createObjectURL(blob); //设置路径
        // console.log(url)
        if (res.data.code == 0) {
          const link = window.document.createElement("a"); // 创建a标签
          link.href = res.data.data;
          link.download = "receipt.zip"; //设置文件名
          link.style.display = "none";
          link.click();
          // URL.revokeObjectURL(url); // 释放内存
        } else {
          this.$message({
            type: "error",
            message: "回单下载失败    " + res.data.msg,
          });
        }
      });
    },
    // 回单生成
    compact(r) {
      let params = {
        totalAmount: 10,
        tradeAccpTxno: "2022111317131773",
        tradeBillType: "REFUND",
      };

      this.$http
        .post("/api/receipt/receiptDownload", params, {
          responseType: "blob",
        })
        .then((res) => {
          // let blob = new Blob([res.data], { type: 'application/zip' }); //设置下载的内容以及格式
          // console.log(blob)
          // const url = window.URL.createObjectURL(blob); //设置路径
          // console.log(url)
          if (res.data.code == 0) {
            const link = window.document.createElement("a"); // 创建a标签
            link.href = res.data.data;
            link.download = "receipt.zip"; //设置文件名
            link.style.display = "none";
            link.click();
            // URL.revokeObjectURL(url); // 释放内存
          } else {
            this.$message({
              type: "error",
              message: "回单下载失败    " + res.data.msg,
            });
          }
        });
    },

    getStates() {
      return this.$http.get(this.mixinViewModuleOptions.getDataListURL, {
        params: {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage
            ? this.page
            : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage
            ? this.limit
            : null,
          ...this.dataForm,
        },
      });
    },
    // 签约成功跳转页面到签约成功
    async signedOK(row) {
      this.applyId = row.id;
      this.signObj = row;
      this.getFactor();

      let res = await this.getStates();
      let { data } = res;

      if (data.code == 0) {
        let arr = data.data.list.filter((item) => item.id == this.signObj.id);
        console.log(arr[0]);

        if (arr[0].applyStatus == "4" || arr[0].applyStatus == "8") {
          this.signed = false;
          this.addOrUpdateCloanVisible = true;
          this.$nextTick(() => {
            // this.$refs.addOrUpdatecloan.dialogVisibleok = true

            this.$refs.addOrUpdatecloan.getLoanData(this.signObj.id);
          });
        } else {
          this.$message({
            type: "warning",
            message: "签约未完成",
          });
        }
      }
    },
     async handleExport() {
      try {
        this.isExporting = true 
        await this.orderExport()
      } catch (error) {
        console.error('导出失败:', error)
      } finally {
        this.isExporting = false
      }
    },
     orderExport() {
      return this.$http.get(
        `${this.mixinViewModuleOptions.exportURL}`,
        {
          params: this.dataForm
        }
      ).then(response => {
        if (response.data.code != 0) {
          this.$message.error(response.data.msg);
        } else {
          this.exportDialogVisible = true; 
          this.$message.success(response.data.msg);
        }
      }).catch(error => {
        const errorMsg = this.parseError(error)
        this.$message.error(errorMsg)
        throw error
      });
    },
    goToDownloadPage() {
        this.exportDialogVisible = false;
        this.$router.push({ path: '/loan-orderexportfile' }); 
      },
  },
  components: {
    AddOrUpdate,
    AddOrUpdateloan,
    AddOrUpdatee,
    Pdf,
    perfect,
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(66px, 140px);

  width: 600px !important;
  height: 380px;
  text-align: center;
  z-index: 999999999999;
  h3 {
    margin: 30px;
  }
  .card-btn {
    width: 60%;
    margin: 60px auto;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 80px 0;

    justify-content: space-around;
  }
  p:nth-child(2) {
    margin: 130px 0;
    span {
      color: blue;
    }
  }
  ul {
    width: 100%;
    margin: 30px 0;
    padding-left: 168px;

    li {
      width: 100%;
      text-align: left;
      margin: 5px 0;
      span:nth-child(1) {
        width: 100px !important;
      }
      span {
        font-size: 12px;
        display: inline-block;
        text-align: left;
      }
    }
  }
}
.card-btn {
  display: flex;
  width: 82%;
  margin: 0 auto;
  justify-content: space-between;
  button {
    border: none;
    background: #3b46c4;
    width: 90px;
    height: 40px;
    border-radius: 4px;
    font-weight: 900;
    color: #fff;
  }
}

.mo {
  width: 200px;
  margin: 20px auto;
  height: 35px;
  line-height: 35px;
  background: #e9eafa;
  border-radius: 4px;
  color: #3d4090;
  > span {
    background: #e9eafa;
  }
}
.box-card1 {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translateX(100px);
  width: 920px;
  height: 380px;
  text-align: center;
  z-index: 999999999999;
  .p2 {
    margin: 20px 0;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
  position: relative;
  padding: 0px 15px;
  box-sizing: border-box;
  .input-code {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0px;
    top: 0px;
    box-sizing: border-box;
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
  .code-item {
    width: 40px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid#D8D8D8;
    margin-right: 10px;
    color: #444;
    font-size: 34px;
  }
  .code-item-active {
    border-bottom: 1px solid#F23026;
  }
}
.blue {
  color: blue;
  cursor: pointer;
}
.ipt_pwd {
  width: 245px;
  height: 37px;
  position: relative;
  // border: 1px solid #333;
  margin-right: 20px;
}
.passWord-box {
  border: 2px solid #ccc;
  border-radius: 15px;
  width: 300px;
  margin: 0px auto;
}

.get-password-box {
  display: flex;
  width: 346px;

  margin: 100px auto !important;
  justify-content: space-between;
}
.box-contract {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-icon-star-on {
    font-size: 18px;
    color: #17b3a3;
    margin: 0 10px;
  }
}
.agreement {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  color: blue;
}

.box-yzm {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(92px, 75px);
  width: 500px;
  height: 380px;
  p {
    text-align: center;
  }
  .p2 {
    margin: 20px 0;
  }
  .footer-btn {
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
  position: relative;
  padding: 0px 15px;
  box-sizing: border-box;
  .input-code {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0px;
    top: 0px;
    box-sizing: border-box;
    color: transparent;
    background-color: transparent;
    opacity: 0;
  }
  .code-item {
    width: 40px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid#D8D8D8;
    margin-right: 10px;
    color: #444;
    font-size: 34px;
  }
  .code-item-active {
    border-bottom: 1px solid#F23026;
  }
}
.mobile-box {
  display: inline-block;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  > span {
    display: inline-block;
    width: 100px;
  }
}
.yellow {
  color: #facd56 !important;
}
.upload_offer{
  display: flex;
}
.upload_offer img{
  width: 20px;
  height: 20px;
}
.look-idNo{
  border: 1px solid;
  padding: 2px 5px;
 }
 .look-dialog{
  display: flex;
  justify-content: space-around;
  font-size: 26px;
  color: #8c8c8c;
  .img-box{
    width: 300px;
    height: 200px;
    img{
      width: 100%;
      height: 100%;
    }
    // border: 1px solid;
   
  }
  .title{
    text-align: center;
  }
  .idNO-img{
    margin: 50px 0;
  }
 }
 .look-title{
  display: flex;
  align-items: center;
  img{
    width: 40px;
    margin-right:20px ;
  }
  span{
    color: #8c8c8c;
    font-size: 28px;
    font-weight: bold;
  }
 }
 .release{
  margin-top: 6px;
  border: 1px solid #e6252587;
  color: #e62525;
  background-color:  #e6252521;
  border-radius: 5px;
  padding: 2px 16px 0;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
 .cancel_agree{
  margin-top: 6px;
  border: 1px solid #34c0af91;
  color: #2cb3a3;
  background-color:   #34c0af4a;
  border-radius: 5px;
  padding: 2px 16px 0;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
 .resign_agree{
  margin-top: 6px;
  // border: 1px solid #34c0af91;
  color: #fff;
  background-color:   #34c0af;
  border-radius: 5px;
  padding: 4px 16px 2px;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
 .agreement_btn{
  margin-top: 6px;
  border: 1px solid #0000ff7d;
  color: #0000ff;
  background-color:   #0000ff1c;
  border-radius: 5px;
  padding: 2px 16px 0;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
 .clearance{
  margin-top: 6px;
  border: 1px solid #f59a23;
  color: #f59a23;
  background-color:  #f59a230d;
  border-radius: 5px;
  padding: 2px 16px 0;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
 }
 .copy_link{
    text-align: center;
    margin: 50px auto;
 }
 .withhold_box{
  display: flex;
  margin: 40px;
  justify-content: center;
  align-items: center;
  .el-input{
    width: 260px;
    margin-left: 10px;
  }
 }
//  .table-container{
//     height: 60vh;
//     overflow-y: auto;
//  }
// @media (max-width: 1920px) {
//   .table-container {
//     height: 50vh; 
//   }
// }
// @media (min-width: 1921px) and (max-width: 2559px) {
//   .table-container {
//     height: 60vh; /* 在中等屏幕上设置适中的高度 */
//   }
// }
// @media (min-width: 2560px) {
//   .table-container {
//     height: 73vh; /* 在大屏幕上使用默认高度 */
//   }
// }
.custom-export-dialog {
  ::v-deep .el-dialog.el-dialog--center {
    .el-dialog__body {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      padding: 20px 30px !important;
      min-height: 120px;
    }
  }

  .dialog-text {
    font-size: 18px;
    width: 100%;
    margin: 0;
    line-height: 1.6;
    
    b {
      font-weight: bold;
      color: #333;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 30px; 
    padding: 20px 30px 30px;

    .el-button:not(:last-child) {
      margin-right: 30px;
    }

    .el-button {
      margin: 0;
      min-width: 100px;
      padding: 12px 24px;
    }
  }
}
</style>
